export const colorsList = [
  "#033666",
  "#00D1FF",
  "#0068A7",
  "#0092CA",
  "#00A7DC",
  "#03457B",
  "#01B2F5",
  "#0077B3",
  "#00B5E4",
  "#00C6F2",
  "#023E73",
  "#02A9F2",
  "#0083C2",
  "#00D9F5",
];

export const salesTypeInsights = [
  {
    name: "Quantity by Month for Top 5 States",
    insight: `Recommendations and Predictions:
As the CFO of HPCL, I propose the following strategic measures to increase revenue:
1. Optimize High-Performing States
   • Expand our retail outlet network in Uttar Pradesh and Maharashtra, our top two performing states, by 10% over the next fiscal year. This can be implemented by identifying high-potential locations along major highways and urban centers.
   • Introduce premium fuel products in these states, targeting a 5% market share within the first year. We'll launch marketing campaigns highlighting the benefits of these products to drive adoption.

2. Enhance Product Mix in Growth Markets
   • In Karnataka, Tamil Nadu, and Gujarat, focus on increasing the sales of high-margin products like XTRAPREMIUM petrol and XTRAMILEPREMIUM diesel by 15%. Implementation will involve targeted promotions and loyalty programs for frequent customers.
   • Analyze the product mix in these states and adjust inventory levels to ensure optimal stock of high-demand products, potentially increasing overall sales volume by 7-10%.

3. Leverage Geographic and Infrastructure Data
   • Utilize our 'Highway Type' and 'Highway No' data to identify strategic locations for new retail outlets or upgrading existing ones, particularly along National Highways in the top 5 states. 
   • Implement a data-driven approach to optimize pricing strategies based on 'District' and 'City' level demand patterns, potentially increasing profit margins by 2-3% in these key markets.
These measures, when implemented successfully, could potentially increase the overall revenue from these top 5 states by 7-9% in the next fiscal year. This strategy focuses on a mix of volume growth, pricing optimization, product diversification, and operational efficiency to drive revenue growth while considering the specific market conditions and opportunities in each state.
`,
  },
  {
    name: "Comparison of Sales by Class of Mkt",
    insight: `As the CFO of HPCL, I've analyzed our sales data across different market classes and propose the following strategic measures to enhance our revenue:
1. Market Class Prioritization
   • We will increase our focus on M4, N8, and Y class markets, which have shown consistent high performance. Our team will develop a plan to allocate an additional 8% of our marketing budget to these classes in the upcoming quarter.
   • To implement this, we'll collaborate with our marketing department to create targeted campaigns and customer loyalty programs specific to these market classes, aiming for a 5% increase in sales within six months.

2. Performance Improvement Initiative
   • We need to address the declining performance in our H class markets. I propose we initiate a comprehensive review of these locations, analyzing factors such as competition, pricing strategy, and local market conditions.
   • Implementation will involve forming a cross-functional team to conduct this analysis. We'll set a deadline of 45 days for them to present their findings and recommendations for reversing the negative trend.

3. Strategic Expansion
   • The high growth rates in L and T class markets present an opportunity we shouldn't overlook. We'll explore the potential for strategic expansion in these segments.
   • To execute this, we'll select three pilot locations in each of these market classes for testing expanded services or product offerings. We'll allocate resources to support this initiative and evaluate the results over a four-month period.
By focusing on these areas, we aim to optimize our market approach and drive sustainable revenue growth across our diverse portfolio.
`,
  },
  {
    name: "States with Maximum Increase in Quantity",
    insight: `As the CFO of HPCL, I propose the following strategic measures to increase our revenue:

1. Regional Market Optimization
   • We will prioritize resource allocation to high-performing states like Meghalaya and Assam, aiming to capitalize on their positive growth trends. This involves expanding our distribution network and increasing marketing efforts in these regions.
   • For underperforming states such as Andhra Pradesh, we'll initiate a comprehensive market analysis to identify root causes of negative growth and develop tailored strategies to reverse these trends.

2. Seasonal Demand Management
   • Given the observed monthly variations in quantity increases, we'll implement a dynamic inventory management system. This system will adjust our supply chain to align with seasonal demand patterns, optimizing our stock levels and reducing carrying costs.
   • We'll introduce a flexible pricing strategy that responds to seasonal fluctuations. This approach will allow us to maintain competitive pricing during peak demand periods while preserving profit margins during slower months.

3. Data-Driven Decision Making
   • We'll invest in advanced analytics capabilities to gain deeper insights into market trends, consumer behavior, and operational efficiency across our diverse state portfolio.
   • A cross-functional team will be established to regularly review these insights and implement data-driven strategies. This team will focus on identifying opportunities for revenue growth and operational improvements across all regions.
   By implementing these strategic initiatives, we aim to drive sustainable revenue growth while optimizing our operations across India's diverse market landscape.
`,
  },
  {
    name: "Quantity by Zone",
    insight: `As the CFO of HPCL, I propose the following strategic measures to increase our revenue:

1. Zone-Specific Growth Initiatives
   • We will allocate additional marketing resources to our top-performing zones - West, North Central Retail, and South West. Our goal is to further capitalize on their strong performance, aiming for a 10-15% increase in sales in these areas over the next fiscal year.
   • For our underperforming zones like North West Frontier, North West Retail, and North Frontier, we'll conduct targeted market research. Based on the insights gathered, we'll develop customized product offerings and region-specific promotions, with the objective of boosting sales volume by 20% in these areas within 18 months.

2. Operational Optimization
   • In our high-volume zones, we'll invest in enhancing our supply chain and distribution network. This includes upgrading our logistics capabilities and implementing advanced forecasting tools. We anticipate this will reduce supply chain costs by 8-10% while maintaining consistent product availability.
   • For zones with lower sales volumes, we'll conduct a thorough cost-benefit analysis of our operations. This may lead to strategic consolidation of certain retail outlets or resource redistribution, aiming to improve overall operational efficiency by 15% in these regions.

3. Data-Driven Strategy Enhancement
   • We'll invest in advanced analytics tools to gain deeper insights into sales patterns and market trends across all zones. This initiative is expected to improve our overall sales effectiveness by 5-7% through more informed decision-making on product placement, pricing, and promotional activities.
   • We'll implement real-time performance monitoring dashboards for each zone, tracking key performance indicators. Our target is to reduce our response time to market fluctuations by 30%, allowing us to adapt quickly to changing market conditions.
By implementing these measures, we aim to increase our total sales by approximately 11.5 million units in the next fiscal year, representing a growth of about 41% over our current sales. This ambitious target will require close monitoring and may need adjustments based on market conditions and execution challenges. We should also focus on cost optimization and efficiency improvements to ensure that this revenue growth translates into increased profitability for HPCL.`,
  },
];
export const supplyChainInsights = [
  {
    name: "Top 10 Districts by Quantity",
    insight: `As the CFO of HPCL, I've analyzed the sales data for our top 10 districts, and I propose the following strategic measures to increase our revenue:

1. Capitalize on High-Performing Markets
   • We should consider increasing our investment in MH-PUNE (POONA) and KA-BANGALORE-URB, our top two markets, by expanding our retail network and storage facilities. These districts show exceptional performance, with sales volumes over 590,000 units each.
   • We'll initiate a comprehensive market analysis in these areas to identify the factors driving their success, which we can potentially replicate in other high-potential markets.

2. Boost Mid-Tier Performers
   • For districts ranking 3rd to 6th (GJ-AHMEDABAD, TG-RANGA REDDY, TN-MADRAS, and MH-THANE), we'll develop tailored growth strategies. These markets show solid performance with sales between 250,000 to 290,000 units.
   • We'll allocate additional marketing resources to these areas, focusing on customer retention programs and targeted promotions to drive sales volume closer to our top performers.

3. Address Lower-Performing Districts
   • For the districts ranking 7th to 10th, particularly KA-BELGAUM, we'll conduct a thorough review of our operations and market presence. These districts, while still in our top 10, show room for improvement with sales ranging from 226,000 to 250,000 units.
   • We'll explore strategic partnerships with local businesses and consider infrastructure improvements to enhance our distribution efficiency in these areas.
By implementing these measures, we aim for a total revenue increase of 14-15% in the next fiscal year. We'll need to monitor these initiatives closely and adjust our strategies based on quarterly performance reviews`,
  },
  {
    name: "Quantity by Month",
    insight: `As the CFO of HPCL, I've analyzed our sales data and identified key strategies to increase revenue. Here are the measures we'll implement:
1. Product Optimization
   • We'll focus on promoting our GAJ product, which shows slightly higher sales volume. Our marketing team will develop targeted campaigns to boost GAJ sales, particularly in high-performing regions.
   • We'll conduct a thorough analysis of profit margins for both GAJ and SH products. This will inform our inventory management and distribution strategies to maximize overall profitability.
2. Regional Strategy
   • Our data indicates strong performance in certain areas, such as West Bengal. We'll allocate additional resources to these high-performing regions to capitalize on existing momentum and further drive sales.
   • For underperforming areas like Arunachal Pradesh, we'll initiate market research to understand local challenges. Based on these insights, we'll develop tailored strategies to improve sales in these regions.
3. Seasonal Adjustments
   • Noting the sales spike in May, we'll prepare for next year by increasing inventory and intensifying marketing efforts leading up to this period.
   • To address the June decline, we'll explore promotional activities and partnerships with local businesses to stimulate demand during slower periods.
These measures, focusing on product strategy, pricing, expansion, customer engagement, and operational efficiency, should help drive revenue growth. We'll need to closely monitor the results and adjust strategies as needed based on market responses and economic conditions.

`,
  },
  {
    name: "RO Type Distribution",
    insight: `As CFO of HPCL, I propose the following strategic measures to enhance our revenue stream:
1. Optimize High-Performing RO Types
   • Increase investment in OFXW and FLXR type retail outlets, which collectively represent 99% of our distribution network.
   • Implement a performance-based incentive program for these outlets to drive sales and efficiency.
2. Evaluate Low-Performing RO Types
   • Conduct a cost-benefit analysis of WMRQ and QOZFA outlets to determine their viability.
   • Consider repurposing or upgrading underperforming outlets to the more successful OFXW or FLXR models.
3. Data-Driven Decision Making
   • Leverage our 'Class of Mkt' and 'Highway Type' data to identify optimal locations for new OFXW and FLXR outlets.
   • Analyze 'Quantity' and 'cumm_Quantity' trends to forecast demand and adjust supply chain logistics accordingly.
These measures aim to capitalize on our strengths while addressing potential weaknesses in our retail network. By focusing on our most successful outlet types and strategically positioning them, we can drive revenue growth and operational efficiency.`,
  },
  {
    name: "Product Quantity",
    insight: `As the CFO of HPCL, I propose the following strategic measures to increase revenue:
1. Product and Market Focus
   • Increase GAJ production capacity by 15%, targeting high-demand states like Uttar Pradesh and Maharashtra. This could potentially boost revenue by 10-12% in these key markets.
   • Conduct a comprehensive market analysis in states with lower sales volumes to identify growth opportunities and tailor our product mix accordingly.
2. Distribution Network Optimization
   • Expand our retail network in top-performing states, aiming for a 20% increase in outlets over the next fiscal year, with a particular focus on Uttar Pradesh, Maharashtra, and Karnataka.
   • Implement an advanced inventory management system to ensure optimal stock levels of GAJ across our distribution channels, reducing stockouts and improving sales efficiency.
3. Pricing and Customer Retention Strategies
   • Develop a dynamic pricing model for GAJ, adjusting prices based on regional demand patterns and seasonal fluctuations observed in our top 5 states.
   • Launch a loyalty program for bulk purchasers of GAJ, targeting a 5% increase in repeat business, with special incentives for customers in high-volume states.
By implementing these measures, we aim to leverage our strengths in high-performing products and regions while identifying and capitalizing on growth opportunities in other areas. We will closely monitor the outcomes of these initiatives and be prepared to make data-driven adjustments to our strategy as needed.`,
  },
];

export const salesTypeTemplatesList = [
  {
    templateName: " ",
    templateValue: "",
    isActive: false,
  },
  {
    templateName: "Sales and Revenue Growth",
    templateValue: "Sales_and_Revenue_Growth",
    isActive: true,
  },
  {
    templateName: "Supply Chain Optimization",
    templateValue: "Supply_Chain_Optimization",
    isActive: false,
  },

  {
    templateName: "Custom Dashboard",
    templateValue: "Custom Dashboard",
    isActive: false,
  },
  {
    templateName: "...",
    templateValue: "",
    isActive: false,
  },
];

export const supplyChainTypeTemplatesList = [
  {
    templateName: " ",
    templateValue: "",
    isActive: false,
  },
  {
    templateName: "Inventory Management",
    templateValue: "Inventory_Management",
    isActive: true,
  },
  {
    templateName: "Operational Efficiency",
    templateValue: "Operational_Efficiency",
    isActive: false,
  },

  {
    templateName: "Custom Dashboard",
    templateValue: "Custom Dashboard",
    isActive: false,
  },
  {
    templateName: "...",
    templateValue: "",
    isActive: false,
  },
];

export const setInsightTextBasedOnTemplateType = (templateType) => {
  let insightText = "";
  switch (templateType) {
    case "Supply_Chain_Optimization":
      insightText = `"Based on the given data, I'll provide an analysis of the predicted demand for products for the next quarter and recommendations for inventory and production adjustments. Here's the breakdown:

1. Top states from the given data:
   - Uttar Pradesh
   - Madhya Pradesh
   - Maharashtra
   - Tamil Nadu
   - Rajasthan
   - Karnataka
   - Andhra Pradesh

2. State-wise quantity for June, May, and April:

June:
- Uttar Pradesh: 2,330 (Mirzapur)
- Maharashtra: 450 (Nagpur)
- Tamil Nadu: 590 (Virudhunagar)
- Punjab: 950 (Faridkot)
- Karnataka: 875 (Hassan)

May:
- Rajasthan: 1,350 (Jaipur Rural)
- Uttar Pradesh: 720 (Basti)
- Karnataka: 1,770 (Hassan)
- Maharashtra: 1,260 (Sangli)
- Odisha: 360 (Kalahandi)

April:
- Uttar Pradesh: 2,330 (Azamgarh)
- Tamil Nadu: 3,820 (Karaikal)
- Karnataka: 660 (Davanagere)
- Maharashtra: 590 (Gondia)
- Madhya Pradesh: 510 (Indore)

3. Quantity for each regional office:
   (Note: Limited information available for regional offices)

- North Frontier Zone: 410 (Jammu, June)
- North Central Retail Zone: 1,640 (Moradabad, June)
- South Zone: 740 (Virudhunagar, June)
- West Zone: 330 (Nasik, June)
- East Central Zone: 290 (Begusarai, May)
- South West Zone: 1,770 (Hassan, May)

4. Quantity figures for each Zone and Product-wise:
   (Note: Limited information available for zones and products)

- North Zone: 990 (Haridwar, June)
- South Zone: 740 (Virudhunagar, June)
- East Zone: 290 (Purulia, June)
- West Zone: 330 (Nasik, June)
- Central Zone: 1,320 (Nagpur, June)

Product-wise information is not clearly available in the given data.

5. Insights based on the user query and data:

- There is a significant variation in demand across different states and regions.
- Uttar Pradesh, Maharashtra, and Tamil Nadu consistently show high demand across the months.
- There seems to be a slight increase in demand from April to June in some states.
- Regional disparities in demand are evident, with the North and South zones showing higher quantities compared to other zones.

6. Recommendations for inventory and production adjustments:

a) Implement a dynamic inventory management system:
   - Adjust stock levels based on the state-wise and regional demand patterns observed.
   - Increase inventory for high-demand states like Uttar Pradesh, Maharashtra, and Tamil Nadu.

b) Optimize production schedule:
   - Align production with the observed monthly variations in demand.
   - Increase production capacity for June and May to meet the higher demand in these months.

c) Regional distribution centers:
   - Establish or strengthen distribution centers in key regions like North and South zones to improve supply chain efficiency.

d) Demand forecasting:
   - Develop a more accurate demand forecasting model using historical data and seasonal trends.
   - Consider factors such as local events, weather patterns, and economic indicators that may influence demand.

e) Flexible production capabilities:
   - Invest in flexible manufacturing processes that can quickly adapt to changes in demand across different regions.

f) Collaboration with suppliers:
   - Work closely with suppliers to ensure a steady supply of raw materials, especially for high-demand periods.

g) Monitor and adjust:
   - Continuously monitor sales data and market trends to make real-time adjustments to inventory levels and production schedules.

7. Predictions:

- Based on the observed trends, we can predict that demand may continue to increase in the coming quarter, especially in states like Uttar Pradesh, Maharashtra, and Tamil Nadu.
- The North and South zones are likely to maintain higher demand compared to other zones.
- There might be a seasonal peak in demand during the months of May and June, which could continue into the next quarter.

By implementing these recommendations and closely monitoring the predicted trends, the company can optimize its inventory levels and production schedule to meet the expected demand for the next quarter efficiently
  "`;
      break;
    case "Sales_and_Revenue_Growth":
      insightText = `"Based on the given data, I'll provide an analysis of the sales quantity for June, May, and April, comparing the top states and regions. Please note that the data is limited and may not provide a complete picture for all states and regions.

Top States from the given data:
1. Maharashtra
2. Rajasthan
3. Punjab
4. Uttar Pradesh
5. Gujarat
6. Karnataka
7. Tamil Nadu
8. Andhra Pradesh
9. Telangana
10. West Bengal

State-wise quantity for June, May, and April:

1. Maharashtra:
June: 3,930 (Aurangabad), 2,400 (Nasik), 2,010 (Khandala)
May: 5,400 (Delhi)
April: Data not available

2. Rajasthan:
June: 1,550 (Muktsar), 680 (Udaipur), 2,300 (Ganganagar)
May: 1,750 (Baran)
April: Data not available

3. Punjab:
June: 2,270 (Kapurthala), 1,550 (Muktsar)
May: 350 (Maansa)
April: Data not available

4. Uttar Pradesh:
June: 3,350 (Rampur), 2,560 (Unnao)
May: 2,240 (Rampur)
April: 380 (Raebareli)

5. Gujarat:
June: 2,040 (Botad)
May: Data not available
April: Data not available

Regional Office Quantity:

1. North:
June: 2,270 (Kapurthala), 2,300 (Ganganagar)
May: 5,400 (Delhi), 1,750 (Baran)
April: 380 (Raebareli)

2. West:
June: 3,930 (Aurangabad), 2,400 (Nasik), 2,010 (Khandala)
May: Data not available
April: Data not available

3. South:
June: Data not available
May: Data not available
April: 90 (Srikakulam, Andhra Pradesh)

4. East:
June: 8,520 (Shillong, Meghalaya)
May: Data not available
April: 1,280 (Purba Bardhaman, West Bengal)

Zone-wise and Product-wise Quantity:
Due to limited data, it's not possible to provide a comprehensive breakdown of quantity by zone and product.

Insights:

1. Maharashtra shows the highest quantities across the three months, particularly in June, indicating strong sales performance in this state.

2. There's a significant variation in quantities across states and months, suggesting regional and seasonal fluctuations in demand.

3. The North region seems to have consistent sales across the three months, while data for other regions is more sporadic.

4. June generally shows higher quantities compared to May and April, which could indicate a seasonal trend or increased sales activities during this month.  

5. Some states like Gujarat and Rajasthan show lower quantities compared to Maharashtra, which might suggest opportunities for growth in these markets.      

Recommendations:

1. Focus on replicating the success factors from Maharashtra in other states to boost sales quantities.

2. Investigate the reasons for higher sales in June and consider implementing similar strategies in other months to balance out sales throughout the quarter.

3. Conduct a detailed analysis of the North region's consistent performance to identify best practices that can be applied to other regions.

4. For states with lower quantities, develop targeted marketing and sales strategies to increase market penetration and boost sales.

5. Improve data collection and reporting across all regions to enable more comprehensive analysis and decision-making.

Predictions:

1. If the trend continues, we can expect to see higher sales quantities in July compared to May and April.

2. Maharashtra is likely to remain a top-performing state in the coming months unless significant changes occur in market conditions or company strategy.    

3. The North region may continue to show consistent performance across months, while other regions might see more fluctuations.

Please note that these insights, recommendations, and predictions are based on limited data and would be more accurate with a more comprehensive dataset covering all states, regions, and products consistently across the three months.
"`;
      break;
    case "Inventory_Management":
      insightText =
        "Based on the given data and the query, I cannot provide a direct answer about inventory levels or forecasted demand, as this information is not present in the provided context. However, I can provide some insights based on the available data:\n\n1. Top Suppliers:\n   - Indigo BU (appears multiple times)\n   - Banyan Street\n   - U of M Morris\n   - Bavarian Inn\n   - Los Angeles County (various departments)\n\n2. Sales Revenue Figures:\n   - Banyan Street: $170,000\n   - U of M Morris: $227,793\n   - Bavarian Inn: $82,794\n   - Los Angeles County (various departments): Ranging from $700 to $22,857\n\n5. Insights:\n   - The data suggests a diverse range of suppliers, including parking facilities, educational institutions, and government departments.\n   - Payment terms vary significantly among suppliers, ranging from immediate to net 90 days.\n   - There's a mix of payment methods, with ACH being the most common.\n   - Transaction amounts vary widely, from small amounts like $450 to larger sums like $170,000.\n\n6. Recommendations:\n   - Analyze payment terms to optimize cash flow and potentially negotiate better terms with suppliers.\n   - Investigate the reasons for varying payment methods and consider standardizing to improve efficiency.\n   - Review the frequency of transactions with each supplier to identify key relationships and potential areas for consolidation or expansion.\n\n7. Predictions:\n   - Given the recurring nature of some transactions (e.g., monthly installments), it's likely that these patterns will continue in the future.\n   - The diverse range of suppliers suggests a complex supply chain, which may require ongoing management and optimization.\n\nWhile this analysis provides some insights into supplier relationships and transaction patterns, it does not directly address the query about inventory levels and forecasted demand. To answer that question, additional data on product-specific inventory and demand forecasts would be necessary.";
      break;
    case "Operational_Efficiency":
      insightText =
        "Based on the given data and query, here's an analysis of payment terms by supplier and opportunities for negotiation:\n\nTop Suppliers and Payment Terms:\n1. Supplier 100755882: Net 15\n2. Supplier 100755878: Net 15\n3. Supplier WEY19770: Net 15\n4. Supplier 3449513245: Net 90\n5. Supplier DB48475: Net 7\n6. Supplier DB48478: Net 7\n7. University of Southern California: Net 30\n8. Supplier DB48531: Net 7\n9. Supplier DB48554: Net 7\n10. Supplier 1L7DKQJ7MFP4: Net 30\n11. Supplier 723943: Net 60\n12. Supplier 723929: Net 60\n13. Supplier 741031478: Net 15\n14. Supplier 713916: Net 60\n15. Supplier 55603146: Net 30\n16. Supplier 55723408: Net 30\n17. Supplier 55693207: Net 30\n18. Supplier 55663174: Net 30\n\nSales Revenue Figures:\nDue to limited information in the provided data, exact sales revenue figures for each supplier cannot be determined. However, we can use the payment amounts as an indicator of business volume:\n\n1. Supplier 100755882: $220,000\n2. Supplier 100755878: $627,750\n3. Supplier WEY19770: $26,244\n4. Supplier 3449513245: $12,136\n5. Supplier DB48475: $59,107\n6. Supplier DB48478: $4,575\n7. University of Southern California: $4,790\n8. Supplier DB48531: $10,595\n9. Supplier DB48554: $61,654\n10. Supplier 1L7DKQJ7MFP4: $861\n11. Supplier 723943: $365\n12. Supplier 723929: $365\n13. Supplier 741031478: $11,123\n14. Supplier 713916: $420\n15. Supplier 55603146: $868\n16. Supplier 55723408: $868\n17. Supplier 55693207: $868\n18. Supplier 55663174: $868\n\nInsights and Recommendations:\n\n1. Payment Term Variability: There is a wide range of payment terms across suppliers, from Net 7 to Net 90. This variability suggests opportunities for term standardization and negotiation.\n\n2. Short Payment Terms: Many suppliers have very short payment terms (Net 7 or Net 15). This may put pressure on cash flow. Negotiating longer payment terms with these suppliers could improve working capital management.\n\n3. Longer Payment Terms: Supplier 3449513245 has Net 90 terms, which is significantly longer than others. This could be used as a benchmark to negotiate better terms with other suppliers.\n\n4. High-Value Suppliers: Suppliers 100755882 and 100755878 have the highest transaction values. Given their importance, there may be an opportunity to negotiate better terms based on the volume of business.\n\n5. Standardization Opportunity: Many suppliers (e.g., 55603146, 55723408, 55693207, 55663174) have identical payment terms and transaction amounts. This could indicate a standardized agreement, which could be leveraged across other suppliers.\n\nRecommendations:\n\n1. Negotiate longer payment terms with suppliers currently on Net 7 or Net 15 terms, aiming for at least Net 30 or Net 45.\n\n2. Use the Net 90 terms from Supplier 3449513245 as a benchmark to negotiate with other suppliers, especially those with high transaction values.\n\n3. Implement a supplier segmentation strategy, offering better terms to strategic or high-volume suppliers in exchange for other benefits like price discounts or priority service.\n\n4. Standardize payment terms across similar suppliers to simplify financial operations and improve cash flow predictability.\n\n5. Consider early payment discounts for suppliers with longer payment terms to optimize cash management while maintaining good supplier relationships.\n\nPredictions:\n\n1. If payment terms can be extended by an average of 15 days across all suppliers, it could significantly improve the company's working capital position.\n\n2. Standardizing payment terms could lead to more efficient financial operations and potentially reduce administrative costs associated with managing diverse payment schedules.\n\n3. Negotiating better terms with the top suppliers by volume (100755882 and 100755878) could have the most significant impact on improving overall cash flow management.";
      break;

    default:
      insightText = "NO Insights at this time";
      break;
  }
  return insightText;
};
export const InventoryMangementData = [
  {
    question:
      "Show me the top 5 supplier names by total revenue, including the sum of invoice amounts.",
    template_type: "Inventory_Management",
    chartName: "Revenue Report",
    ChartType: "barChart",

    data: {
      yAxis: [
        {
          data: [6136000, 6136000, 6136000, 5029479.25, 3780000],
        },
      ],
      xAxis: [
        {
          data: [
            "Spire - Montgomery Operations Center",
            "PS Energy - Atlanta",
            "Sheetz Store #353",
            "BRCC - Longueuil 2",
            "Grandstay New London - Tesla Destination",
          ],
          scaleType: "band",
        },
      ],
    },
  },
  {
    question:
      "Show me the average sales cycle length by supplier type, including the average days from invoice creation to payment.",
    template_type: "Inventory_Management",
    chartName: "Average Sales Cycle Length Report",
    ChartType: "pieChart",
    data: {
      yAxis: [
        {
          data: [65.8413, 97.3333, 62.037, 98],
        },
      ],
      xAxis: [
        {
          data: [
            "SUPPLIER",
            "CERTIFIED SEED TREAT CENTER",
            "CONTRACTOR",
            "EMPLOYEE",
          ],
          scaleType: "band",
        },
      ],
    },
  },
  {
    question: "Show me the top 5 suppliers by total Ethanol Gasoline Sales.",
    template_type: "Inventory_Management",
    chartName: "Sales Call Reports",
    ChartType: "pieChart",
    data: {
      yAxis: [
        {
          data: [7391170116, 1905998748, 994074163, 941232129, 640315888],
        },
      ],
      xAxis: [
        {
          data: [
            "U-Haul",
            "Casey's General Store",
            "United Parcel Service",
            "American Natural Gas",
            "Petro-Canada",
          ],
          scaleType: "band",
        },
      ],
    },
  },
  {
    question:
      "Show me the top 5 supplier names by total sales orders, including the number of orders and revenue generated.",
    template_type: "Inventory_Management",
    chartName: "Sales and Order Report",
    ChartType: "barChart",
    data: {
      yAxis: [
        {
          data: [100, 56, 72, 80, 45],
        },
      ],
      xAxis: [
        {
          data: [
            "Spire - Montgomery Operations Center",
            "PS Energy - Atlanta",
            "Sheetz Store #353",
            "BRCC - Longueuil 2",
            "Grandstay New London - Tesla Destination",
          ],
          scaleType: "band",
        },
      ],
    },
  },
];

export const Sales_and_Revenue_Growth_Data = [
  {
    question: "What are the top 5 fuel types by revenue in the last quarter?",
    template_type: "Supply_Sales_and_Revenue_Growth",
    chartName: "Top Fuel Types by Revenue",
    ChartType: "barChart",
    data: {
      yAxis: [
        {
          data: [
            317974848867, 105535077797, 94956834884, 52689263429, 25835160767,
          ],
        },
      ],
      xAxis: [
        {
          data: [
            "Ethanol_Gasoline_Sales",
            "ClearandDyed_Biodiesel_Sales",
            "ClearandDyed_Diesel_Sales",
            "Non-Ethanol Gasoline Sales",
            "Pure_Biodiesel_Sales",
          ],
          scaleType: "band",
        },
      ],
    },
  },
  {
    question: "What is the contribution to revenue growth by fuel type?",
    template_type: "Supply_Sales_and_Revenue_Growth",
    chartName: "Contribution to Revenue Growth by Fuel Type",
    ChartType: "lineChart",
    data: {
      yAxis: [
        {
          data: [
            53.26290512492642, 17.67782847002623, 15.905902323442195,
            8.825802572501305, 4.327561509103848,
          ],
        },
      ],
      xAxis: [
        {
          data: [
            "Ethanol_Gasoline_Sales",
            "ClearandDyed_Biodiesel_Sales",
            "ClearandDyed_Diesel_Sales",
            "Non-Ethanol Gasoline Sales",
            "Pure_Biodiesel_Sales",
          ],
          scaleType: "band",
        },
      ],
    },
  },
  {
    question: "What are the sales trends by region?",
    template_type: "Supply_Sales_and_Revenue_Growth",
    chartName: "Sales Trends by Region",
    ChartType: "barChart",
    data: {
      yAxis: [
        {
          data: [6136000, 6136000, 5029479.25, 3780000, 2300000],
        },
      ],
      xAxis: [
        {
          data: [
            "Montgomery",
            "Monroeville",
            "Montreal",
            "Roseville",
            "West Des Moines",
          ],
          scaleType: "band",
        },
      ],
    },
  },
  {
    question: "What is the sales cycle length by product?",
    template_type: "Supply_Sales_and_Revenue_Growth",
    chartName: "Sales Cycle Length by Product",
    ChartType: "lineChart",
    data: {
      yAxis: [
        {
          data: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11000, 0, 775, 0, 363.62,
            249.31, 85.02, 5211.39, 76.97, 0, 6264, 883.85, 24487.02, 18480.95,
            290661.93, 571327.5, 8284943.48, 11055804.27, 8448445.37,
            32634946.57, 14325885.39, 10123434.2, 17479723.63, 7398571.66,
            5797116.38, 7402219.84, 9395507.45, 10426894.38, 7333522.68,
            6119433.67, 7407568.22, 7511085.3, 4910101.16, 5143994.35,
            5036297.75, 5140884.9, 6057983.4799999995, 4633832.15, 11677784.97,
            4868651.86, 5782459.26, 5944949.8100000005, 5687290.3, 6447282.05,
            3856405.53, 2541944.5700000003,
          ],
        },
      ],
      xAxis: [
        {
          data: [
            "2017-04",
            "2017-05",
            "2017-06",
            "2017-07",
            "2017-08",
            "2017-09",
            "2017-10",
            "2017-11",
            "2017-12",
            "2018-01",
            "2018-02",
            "2018-03",
            "2018-04",
            "2018-05",
            "2018-06",
            "2018-07",
            "2018-08",
            "2018-09",
            "2018-10",
            "2018-11",
            "2018-12",
            "2019-01",
            "2019-02",
            "2019-03",
            "2019-04",
            "2019-05",
            "2019-06",
            "2019-07",
            "2019-08",
            "2019-09",
            "2019-10",
            "2019-11",
            "2019-12",
            "2020-01",
            "2020-02",
            "2020-03",
            "2020-04",
            "2020-05",
            "2020-06",
            "2020-07",
            "2020-08",
            "2020-09",
            "2020-10",
            "2020-11",
            "2020-12",
            "2021-01",
            "2021-02",
            "2021-03",
            "2021-04",
            "2021-05",
            "2021-06",
            "2021-07",
            "2021-08",
            "2021-09",
            "2021-10",
            "2021-11",
            "2021-12",
            "2022-01",
            "2022-02",
            "2022-03",
          ],
          scaleType: "band",
        },
      ],
    },
  },
];

export const staticChartData = [
  {
    data: {
      chartName: "Top Suppliers by Sales Volume",
      yAxis: [
        {
          data: [6136000, 6136000, 5029479.25, 3780000, 2300000],
          lineLabel: "Sales Volume",
          type: "bar",
        },
      ],
      xAxis: [
        {
          data: [
            "PS Energy - Atlanta",
            "Sheetz Store #353",
            "BRCC - Longueuil 2",
            "Grandstay New London - Tesla Destination",
            "Wilkes County - North Carolina DOT",
          ],
          scaleType: "band",
          lineLabel: "Supplier Name",
        },
      ],
    },
  },
  {
    data: {
      chartName: "Payment Method Distribution",
      yAxis: [
        {
          data: [21916, 3663, 445],
          lineLabel: "Payment Method",
          type: "pie",
        },
      ],
      xAxis: [
        {
          data: ["ACH", "Check", "Electronic"],
          scaleType: "band",
          lineLabel: "Payment Method",
        },
      ],
    },
  },
  {
    data: {
      chartName: "Average In-Transit Quantity by Supplier",
      yAxis: [
        {
          data: [217729, 60864, 52999, 44019, 39245],
          lineLabel: "Average In-Transit Quantity",
          type: "bar",
        },
      ],
      xAxis: [
        {
          data: [
            "ARRO Autogas - Visa Petroleum",
            "Waddell Home Hardware",
            "405 Guizot",
            "Rosendin Electric Inc",
            "Icon Parking 16 W 16th Street - Tesla Destination",
          ],
          scaleType: "band",
          lineLabel: "Supplier Name",
        },
      ],
    },
  },
  {
    data: {
      chartName: "Top Suppliers by Average Lead Time and Inventory Levels",
      yAxis: [
        {
          data: [2, 2, 2, 2, 9, 8, 8, 2, 3, 9],
          lineLabel: "Average Lead Time",
          type: "bar",
        },
        {
          data: [192, 5.5, 0, 0, 740, 45, 13, 126, 17, 5],
          lineLabel: "Average Inventory Levels",
          type: "bar",
        },
      ],
      xAxis: [
        {
          data: [
            '"North 40" Parking Lot',
            "#1 Cochran Nissan",
            "#NAME?",
            "01 ST. PAUL SP APT",
            "05 Buckhead Parking Garage - Tesla Destination",
            "1 COLE  EV 1",
            "1 Hotel Brooklyn Bridge - Tesla Destination",
            "1 Hotel South Beach - Tesla Destination",
            "1 Mont-Royal Est",
            "1 VRCNG",
          ],
          scaleType: "band",
          lineLabel: "Supplier Name",
        },
      ],
    },
  },
];
